import { render, staticRenderFns } from "./GstReportSideMenu.vue?vue&type=template&id=1ea480f5&scoped=true"
import script from "./GstReportSideMenu.vue?vue&type=script&lang=js"
export * from "./GstReportSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea480f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea480f5')) {
      api.createRecord('1ea480f5', component.options)
    } else {
      api.reload('1ea480f5', component.options)
    }
    module.hot.accept("./GstReportSideMenu.vue?vue&type=template&id=1ea480f5&scoped=true", function () {
      api.rerender('1ea480f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gstreport/GstReportSideMenu.vue"
export default component.exports